import React from 'react';
import { compose, prop } from 'ramda';
import { FormattedMessage } from 'react-intl';

import connect from 'app/libs/connect';
import renderIf from 'app/enhancers/renderIf';
import S from 'app/features/newLanding/components/newProductComparison/Product/OtherOptionsSeparator.styled';
import Text from 'app/components/layout/Text.styled';
import { hasSpecialTraits } from 'app/features/products/selectors';

const UI = () => (
  <Text as={S.OtherOptionsSeparator} size="xl" type="medium">
    <FormattedMessage id="landing_product_check_out_other_options" />
  </Text>
);

UI.displayName = 'OtherOptionsSeparator';

const OtherOptionsSeparator = compose(
  connect({ hasSpecialTraits }),
  renderIf(prop('hasSpecialTraits')),
)(UI);

export { UI };

export default OtherOptionsSeparator;
